/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSidebarButtons_displayInfo$ref = any;
export type PdpRespSidebarButtons_displayInfo = {
    readonly ctas: {
        readonly showPurchase: boolean | null;
        readonly showMakeOffer: boolean | null;
        readonly showRequestPrice: boolean | null;
        readonly showRequestSourcing: boolean | null;
        readonly showFollowCategory: boolean | null;
        readonly showAcceptOffer: boolean | null;
    } | null;
    readonly " $refType": PdpRespSidebarButtons_displayInfo$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarButtons_displayInfo",
    "type": "ItemDisplayInfo",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "ctas",
            "storageKey": null,
            "args": null,
            "concreteType": "CTADisplay",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showPurchase",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showMakeOffer",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showRequestPrice",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showRequestSourcing",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showFollowCategory",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showAcceptOffer",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'c1ac71653604603c677cf46b8d349be7';
export default node;
